import { Spinner } from "../../components/Spinner/Spinner";
import { useFetchData } from "../../services/useFetchData.service";
import styles from "./Paywall.module.scss";
import { trackGoogleAdsCheckoutStart } from '../../utils/GoogleAdsFunnelEvents';
import { Block } from "../../components/Block/Block";
import { Container } from "../../components/Container/Container";
import { useUserData } from "../../providers/UserDataProvider/useUserData";
import { useNavigate } from "react-router";
import { useSearchParams } from 'react-router-dom';
import { useEffect, useRef, useState } from "react";
import { Timer } from "./Sections/Timer/Timer";
import { Result } from "./Sections/Result/Result";
import { Ticker } from "./Sections/Ticker/Ticker";
import { SelectPlan } from "./Sections/SelectPlan/SelectPlan";
import { Chart } from "./Sections/Chart/Chart";
import { Challenges } from "./Sections/Challenges/Challenges";
import { Benefits } from "./Sections/Benefits/Benefits";
import { UpsaleReview } from "../../components/UpsaleReview/UpsaleReview";
import { Faq } from "./Sections/Faq/Faq";
import { PaymentMethod } from "./Sections/PaymentMethod/PaymentMethod";
import { ContinueButton } from "../../components/ContinueButton/ContinueButton";
import cn from "classnames";
import { Footer } from "../../components/Footer/Footer";
import { useCurrency } from "../../providers/CurrencyProvider/useCurrency";
import { fbAddToCart } from "../../utils/FacebookEvents";
import { ampPaywall } from "../../utils/AmplitudeEvents";


const Paywall = ({dataUrl='/Data/Paywall.json',theme}) => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const {currency } = useCurrency();
  const [hideButton, setHideButton] = useState(false);

  const selectPlanRef = useRef(null);
  const paymentMethodRef = useRef(null);
  useEffect(()=>{
    fbAddToCart();
    ampPaywall('paywall')
  },[])
  useEffect(()=>{
    
  },[selectedPlan])
  useEffect(() => {
    if(theme) {
      document.body.setAttribute('data-theme', theme);
    }else {
      document.body.removeAttribute('data-theme');
    }
  }, [theme]);
  const { userData, setUserData } = useUserData();
  const navigate = useNavigate();
  const { data } = useFetchData(dataUrl);
  const [searchParams] = useSearchParams();
  useEffect(() => {
    if (userData && userData.email) return;
    const emailFromUrl = searchParams.get('email');
    if (emailFromUrl) {
      setUserData({ ...userData, email: emailFromUrl });
    }
  }, [searchParams, userData, setUserData]);

  useEffect(() => {
    // QA-112: the sticky button must stay hidden while any part of the plans or the card form is on screen.
    // A 20% threshold never fired for the tall card form (so the bar covered its Continue button), and one
    // callback only lists the targets that changed, so each target's state is kept.
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };
    const visible = new Map();

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => visible.set(entry.target, entry.isIntersecting));
      setHideButton([...visible.values()].some(Boolean));
    }, options);

    if (selectPlanRef.current) observer.observe(selectPlanRef.current);
    if (paymentMethodRef.current) observer.observe(paymentMethodRef.current);

    return () => {
      if (selectPlanRef.current) observer.unobserve(selectPlanRef.current);
      if (paymentMethodRef.current) observer.unobserve(paymentMethodRef.current);
    };
  }, [data]);


  if (!userData || !userData.email) {
    navigate("/email/");
  }

  if (!data || !currency) {
    return <Spinner />;
  }
  console.log('selectedPlan:',selectedPlan)
  return (
    <Block className={styles.block}>
      <Container className={styles.container}>
        {
          data && data.map((block, idx) => {
            switch (block.blockName) {
              case 'timer':
                return <Timer key={idx} content={block} />;
              case 'result':
                return <Result key={idx} content={block} data={userData}/>
              case 'ticker':
                return <Ticker key={idx} content={block}/>
              case 'selectPlan':
                return <div ref={selectPlanRef} key={idx}>
                  <SelectPlan
                    content={block} 
                    currency={currency}
                    selectedPlan={selectedPlan}
                    setSelectedPlan={setSelectedPlan}
                  />
                </div>
              case 'chart':
                return <Chart key={idx} content={block} />
              case 'challenges':
                return <Challenges key={idx} content={block} />
              case 'benefits' :
                return <Benefits key={idx} content={block} />
              case 'review':
                return <UpsaleReview key={idx} content={block} paginationStatus={true}/>
              case 'paymentMethod':
                return <div ref={paymentMethodRef} key={idx}>
                    <PaymentMethod
                      content={block}
                      currency={currency}
                      data={selectedPlan}
                    />
                  </div>
              case 'faq':
                return <Faq key={idx} content={block} />
              case 'anhorButton':
                return <ContinueButton
                  key={idx}
                  className={cn(
                    styles.button,
                    hideButton && styles.hidden
                  )}
                  onClick={() => {
                    const target = document.getElementById('payment-method');
                    if (target) {
                      target.scrollIntoView({ behavior: 'smooth' });
                      trackGoogleAdsCheckoutStart();
                    }
                  }}
                >
                  {block.button || "Get my result"}
                </ContinueButton>
              case 'footer':
                return (
                  <Footer key={idx} links={block.links} />
                )
              default:
                return null;
            }
          })
        }
      </Container>
    </Block>
  )
}
export default Paywall;
